import React, { useCallback, useEffect, useRef, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, CircularProgress, TextField, Typography } from '@mui/material'
import { api } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import { mainGreen, mainRed } from '../../utils/color'

export default function ShippingService() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [shippingServices, setShippingServices] = useState([])
	const token = getFromStorage('current-user')?.accessToken
	const [loading, setLoading] = useState(false)
	const shippingServiceRef = useRef()

	const getShippingServices = useCallback(
		async function () {
			try {
				setLoading(true)
				const response = await axios({
					url: api.GET_ALL_SHIPPING_SERVICES,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setShippingServices(response.data)
				setLoading(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate],
	)

	useEffect(() => {
		getShippingServices()
	}, [getShippingServices])

	const createShippingService = async function () {
		const name = shippingServiceRef.current.value
		if (name.trim() === '') {
			alert('Nội dung không được để trống!')
			return
		}
		try {
			const response = await axios({
				url: api.CREATE_SHIPPING_SERVICE,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { name },
				method: 'POST',
				withCredentials: true,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getShippingServices()
			shippingServiceRef.current.value = ''
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const deleteShippingService = async function (id) {
		try {
			await axios({
				url: api.DELETE_SHIPPING_SERVICE,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { id },
				method: 'DELETE',
				withCredentials: true,
			})
			await getShippingServices()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				<Box
					sx={{
						marginTop: '10px',
						padding: '20px 0',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						maxWidth: 992,
						marginLeft: 'auto',
						marginRight: 'auto',
					}}>
					<TextField
						fullWidth
						autoFocus
						inputRef={shippingServiceRef}
						sx={{ mb: 2, background: '#fff' }}
						label='Nhập đơn vị giao hàng'></TextField>
					<Button
						size='small'
						fullWidth
						variant='contained'
						sx={{ background: mainGreen, '&:hover': { background: mainGreen } }}
						onClick={() => {
							createShippingService()
						}}>
						Thêm mới
					</Button>
				</Box>
				{loading && (
					<Box sx={{ textAlign: 'center', mt: 4 }}>
						<CircularProgress sx={{ color: mainGreen }} />
					</Box>
				)}
				{!loading &&
					shippingServices?.map((item, index) => {
						return (
							<Card
								sx={{
									margin: '10px 0',
									padding: '10px',
									display: 'flex',
									alignItems: 'flex-end',
								}}
								key={index}>
								<Typography
									sx={{
										color: mainGreen,
										mb: 1,
										fontSize: '20px',
										fontWeight: 'bold',
										padding: '5px 10px',
										borderRadius: '10px',
										letterSpacing: '3px',
									}}>
									{item.name.toUpperCase()}
								</Typography>
								<Button
									sx={{
										marginLeft: 'auto',
										p: 0,
										background: mainRed,
										'&:hover': { background: mainRed },
									}}
									size='small'
									variant='contained'
									onClick={() => {
										const confirmDelete = window.confirm('Bạn có chắc muốn xóa?')
										if (confirmDelete) {
											deleteShippingService(item._id)
										}
									}}>
									Xóa
								</Button>
							</Card>
						)
					})}
			</Box>
		</UserLayout>
	)
}
